import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { call } from '@spacefill/shared/src/utils/Backend';
import { Combobox } from '@spacefill/uikit/src/components/Combobox/Combobox';
import { Loader } from '@spacefill/uikit/src/components/Loader';

import { handleContextSwitch } from '../utils/contextSwitch';

export function AdminCompanySwitcher() {
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const { data: dataCustomerLsp, isFetching } = useQuery({
        queryKey: ['admin/list-customers-lsp', searchQuery],
        queryFn: async () => call('admin/list-customers-lsp', { name: searchQuery }, 'POST'),
        keepPreviousData: true,
    });

    return (
        <Combobox
            placeholder={'Choose a customer/Lsp'}
            options={dataCustomerLsp || []}
            formatOption={(value) => {
                return (
                    <>
                        [{value.value.type.slice(0, 1)}] {value.value.name}
                    </>
                );
            }}
            accessoryElement={loading || isFetching ? <Loader size='small' /> : null}
            setValue={async (value) => {
                if (value) {
                    await handleContextSwitch({
                        switchValue: value,
                        setLoading,
                        currentPathname: location.pathname,
                    });
                }
            }}
            onSearch={(query) => {
                setSearchQuery(query);
            }}
        />
    );
}
